/**
 * Audit Service
 * AIDLC Administrative Backend
 *
 * API calls for audit log queries and session history.
 * Maps to endpoints defined in the Architecture Document, Section 04.
 */

import apiClient from './api';
import type { AuditLogEntry, SessionRecord, AuditAction } from '../types/audit';

const AUDIT_PATH = '/audit';
const SESSIONS_PATH = '/sessions';

export interface AuditQueryParams {
  agentId?: string;
  action?: AuditAction;
  projectId?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

/**
 * Query audit logs with filters
 */
export async function queryAuditLogs(
  params: AuditQueryParams
): Promise<{ entries: AuditLogEntry[]; total: number }> {
  const response = await apiClient.get(AUDIT_PATH, { params });
  return response.data;
}

/**
 * Get every session record (no project filter)
 */
export async function getAllSessions(): Promise<SessionRecord[]> {
  const response = await apiClient.get<SessionRecord[]>(SESSIONS_PATH);
  return Array.isArray(response.data) ? response.data : [];
}

/**
 * Get session records for a project
 */
export async function getSessionsByProject(
  projectId: string
): Promise<SessionRecord[]> {
  const response = await apiClient.get<SessionRecord[]>(SESSIONS_PATH, {
    params: { projectId },
  });
  return response.data;
}

/**
 * Get a single session record
 */
export async function getSessionById(
  sessionId: string
): Promise<SessionRecord> {
  const response = await apiClient.get<SessionRecord>(
    `${SESSIONS_PATH}/${sessionId}`
  );
  return response.data;
}
